import { type FC, type ReactNode } from 'react';
import { ChevronDown } from 'lucide';

// MUI
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

// common
import Icon from 'common/components/Icon';

interface StyledAccordionProps {
  children: ReactNode;
  label: string;
  isDefaultExpanded?: boolean;
}

const StyledAccordion: FC<StyledAccordionProps> = (props) => {
  const { children, label, isDefaultExpanded = false } = props;

  return (
    <Accordion
      defaultExpanded={isDefaultExpanded}
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: '12px',
        boxShadow: 'none',
        '&::before': { display: 'none' },
      }}
    >
      <AccordionSummary expandIcon={<Icon icon={ChevronDown} />}>
        <Typography sx={{ fontWeight: 700 }}>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default StyledAccordion;
